import { IconSvg } from "../common/utils/assets";
import Dashboard from "../views/Dashboard";

export const MapPathRoute2Name = {
  dashboard: "Dashboard",
  settings: "Settings",
};

export const RouteIds = {
  Dashboard: "dashboard",
  Settings: "settings"
};

export const DCERouteIds = {
  Detail: ":id",
  New: "new",
};

export const RoutePaths = {
  Dashboard: ["", RouteIds.Dashboard].join("/"),
  Settings: ["", RouteIds.Settings].join("/"),
};

export const AdminRoutes = {
  Monitor: {
    id: RouteIds.Dashboard,
    iconSvg: IconSvg.AdminiSvg,
    label: MapPathRoute2Name[RouteIds.Dashboard],
    path: RoutePaths.Dashboard,
    component: Dashboard,
  },

  // Admin: {
  //     id: 'Admin',
  //     label: 'System',
  //     iconSvg: IconSvg.AdminiSvg,
  //     path: [RoutePaths.Settings],
  //     children: [
  //         {
  //             exact: true,
  //             id: RouteIds.Settings,
  //             label: MapPathRoute2Name[RouteIds.Settings],
  //             path: RoutePaths.Settings,
  //             component: Settings,
  //         },
  //     ],
  // },
};
